import useTechnicalReportLevel from "./useTechnicalReportLevel";

/** Report level hook for complaint list reports using ComplaintsHierarchyFilters. */
export default function useComplaintsReportLevel({
  code,
  userHierarchy,
  cfcLevelId,
  hierarchy,
  offCode,
  subDivisions,
  selectedCompanyCode,
  selectedAdminCompanyCode,
  officeCode,
  circleCode,
  selectedDivision,
  selectedSubDivision,
  setCircleCode,
  setCircleName,
  setSelectedDivision,
  setSelectedSubDivision,
  setFilteredCircles,
  setFilteredDivisions,
  setFilteredSubDivisions,
  setOfficeCode,
  setOfficeName,
  getCompanies,
  getName,
}) {
  const reportLevelState = useTechnicalReportLevel({
    code,
    userHierarchy,
    cfcLevelId,
    hierarchy,
    offCode,
    subDivisions,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    officeCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    setCircleCode,
    setCircleName,
    setSelectedDivision,
    setSelectedSubDivision,
    setFilteredCircles,
    setFilteredDivisions,
    setFilteredSubDivisions,
    setOfficeCode,
    setOfficeName,
    getCompanies,
    getName,
  });

  const {
    reportLevel,
    setAppliedReportLevel,
    availableReportLevelOptions,
    handleReportLevelChange,
    showCircleFilter,
    showDivisionFilter,
    showSubDivisionFilter,
    circleFilterEnabled,
    divisionFilterEnabled,
    subDivisionFilterEnabled,
    resolveApiOfficeCode,
  } = reportLevelState;

  const reportLevelFilterProps = {
    useReportLevel: true,
    reportLevel,
    onReportLevelChange: handleReportLevelChange,
    availableReportLevelOptions,
    showCircleFilter,
    showDivisionFilter,
    showSubDivisionFilter,
    circleFilterEnabled,
    divisionFilterEnabled,
    subDivisionFilterEnabled,
  };

  return {
    reportLevel,
    setAppliedReportLevel,
    resolveApiOfficeCode,
    reportLevelFilterProps,
  };
}
